module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-4-14b9f8578a9cad658427f929ababf43d.png";